import {
  Box,
  Button,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import LoggoSelector from "../../../loggos/LoggoSelector";

import "react-datepicker/dist/react-datepicker.css";

import "rc-time-picker/assets/index.css";
import { OfiDateTimeRangePicker } from "../../Helpers/Time";
import { toast } from "react-toastify";
import { Competition_GET } from "../../../Api/dto/Competition_GET";
import QRCode from "react-qr-code";
import { PaymentMethodE } from "../../../Api/dto/Competition_POST_PUT";
import { MultiSelect } from "../../Helpers/MultiSelect";
import { requestGET } from "../../../Api/HttpRequestHelpers";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';
export const NOT_VALID_COMPETITION_ID = -1;

export function CreateEventModal(props: {
  competitionToEdit?: Competition_GET;
  onClose: () => void;
  onSave: (event: Competition_GET) => void;
}) {
  const [event, setEvent] = useState<Competition_GET>(
    props.competitionToEdit ?? {
      id: NOT_VALID_COMPETITION_ID,
      tag: null,
      name: null,
      description: null,
      place: null,
      targetParticipant: null,
      maxAge: null,
      minAge: null,
      startTime: null,
      endTime: null,
      paymentMethods: [
        {
          paymentMethod: PaymentMethodE.SWISH_AUTO,
          feeInSek: 0,
          requireManualVerify: false,
        },
      ],
      imageSrc: null,
      deleted: false,
      oldResultsTags: [],
    }
  );

  const [oldResultFiles, setOldResultFiles] = useState<string[]>([]);
  useEffect(() => {
    fetchFileList().then((r) => {
      setOldResultFiles(r);
    });
  }, []);

  const [showQrCode, setShowQrCode] = useState(false);

  const downloadQRCode = (event: any) => {
    const svgImage = event.currentTarget;

    // Create a canvas element
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Create an Image element
    const image = new Image();
    image.onload = () => {
      // Set canvas dimensions to match SVG dimensions
      canvas.width = svgImage.clientWidth;
      canvas.height = svgImage.clientHeight;

      // Render the SVG image onto the canvas
      context?.drawImage(image, 0, 0);

      // Convert canvas to PNG data URL
      const pngUrl = canvas.toDataURL("image/png");

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "QRCode.png";

      // Initiate the download
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    // Set the source of the Image element to the SVG image
    const svgData = new XMLSerializer().serializeToString(svgImage);
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      svgData
    )}`;
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      scrollBehavior={"inside"}
      isOpen={true}
      size={"full"}
      onClose={() => {
        props.onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent
        background={"white"}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <ModalHeader fontSize={"4xl"}>Skapa Tävling</ModalHeader>
        <ModalCloseButton />
        <ModalBody
          scrollBehavior={"auto"}
          scrollSnapType={"block"}
          margin={"20px"}
          overflowY={"auto"}
        >
          <Tabs onChange={() => {}}>
            <TabList>
              <Tab>Långlopp</Tab>
              <Tab>Friidrotts tävling</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <div style={{ marginBottom: "60px" }}>
                  <VStack align="left">
                    <VStack align="left">
                      <Heading size={"sm"}>Tag</Heading>
                      <Input
                        marginLeft={"10px"}
                        width="sm"
                        textColor={"black"}
                        placeholder="Stadsloppet-2024"
                        value={event?.tag ?? ""}
                        onChange={(e) => {
                          setEvent((old) => ({
                            ...old,
                            tag: e.target.value.replaceAll(
                              /[^0-9a-zA-Z_-]/g,
                              ""
                            ),
                          }));
                        }}
                      />
                      {event.tag && (
                        <Text
                          fontSize={"lg"}
                          fontStyle={"italic"}
                          marginLeft={"20px"}
                          textColor={"blue.500"}
                        >{`Url: https://${window.location.hostname}}/tavlingar/${event.tag}`}</Text>
                      )}
                    </VStack>
                    <Button
                      hidden={!event.tag}
                      onClick={() => setShowQrCode((old) => !old)}
                      width={"fit-content"}
                    >
                      {showQrCode ? "Dölj QR-kod" : "Visa QR-kod"}
                    </Button>
                    {showQrCode && (
                      <Box
                        marginLeft={"20px"}
                        display={{ base: "none", lg: "block" }} // Adjust display property as needed
                        width="fit-content"
                        height="fit-content"
                        overflow="hidden"
                        _hover={{
                          transform: "scale(1.1)", // Enlarge on hover
                          transition: "transform 0.3s ease-in-out", // Smooth transition for the enlargement
                        }}
                      >
                        <QRCode
                          value={`https://${window.location.hostname}/tavlingar/${event.tag}`}
                          onClick={downloadQRCode}
                        />
                      </Box>
                    )}

                    <Heading size={"sm"} marginTop={"20px"}>
                      Namn
                    </Heading>
                    <Input
                      marginLeft={"10px"}
                      marginBottom={"20px"}
                      width="sm"
                      textColor={"black"}
                      placeholder="Stadsloppet"
                      value={event?.name ?? ""}
                      onChange={(e) => {
                        setEvent((old) => ({ ...old, name: e.target.value }));
                      }}
                    />
                    <Heading size={"sm"}>Plats</Heading>
                    <Input
                      marginLeft={"10px"}
                      marginBottom={"20px"}
                      width="sm"
                      textColor={"black"}
                      placeholder="Frösåkersvallen, Skolvägen 3, 742 35 Östhammar"
                      value={event?.place ?? ""}
                      onChange={(e) => {
                        setEvent((old) => ({
                          ...old,
                          place: e.target.value,
                        }));
                      }}
                    />
                    <Heading size={"sm"}>Tävlings beskrivning</Heading>
                    <Textarea
                      marginLeft={"10px"}
                      marginBottom={"20px"}
                      width="lg"
                      textColor={"black"}
                      placeholder="Tävlingsbeskrivning..."
                      value={event?.description ?? ""}
                      onChange={(e) => {
                        setEvent((old) => ({
                          ...old,
                          description: e.target.value,
                        }));
                      }}
                    />
                    <Heading size={"sm"}>Start och slut datum</Heading>
                    <OfiDateTimeRangePicker
                      start={
                        event.startTime == null
                          ? null
                          : new Date(event.startTime)
                      }
                      end={
                        event.endTime == null ? null : new Date(event.endTime)
                      }
                      setStart={(date) => {
                        setEvent((old) => {
                          return { ...old, startTime: date?.getTime() ?? null };
                        });
                      }}
                      setEnd={(date) => {
                        setEvent((old) => {
                          return { ...old, endTime: date?.getTime() ?? null };
                        });
                      }}
                    />
                    <Heading size={"sm"}>Deltagare</Heading>
                    <Input
                      marginLeft={"10px"}
                      marginBottom={"20px"}
                      width="sm"
                      textColor={"black"}
                      placeholder="Vem får delta? Ex: För alla åldrar"
                      value={event?.targetParticipant ?? ""}
                      onChange={(e) => {
                        setEvent((old) => ({
                          ...old,
                          targetParticipant: e.target.value,
                        }));
                      }}
                    />
                    <Heading size={"sm"}>
                      Visa gamla resultat (frivilligt)
                    </Heading>
                    <MultiSelect
                      title=""
                      displayValues={oldResultFiles.map((n) =>
                        n.replace(".json", "")
                      )}
                      values={oldResultFiles.map((n) => n.replace(".json", ""))}
                      onChange={(selection) => {
                        console.log(selection);
                        setEvent((old) => ({
                          ...old,
                          oldResultsTags: selection as Array<string>,
                        }));
                      }}
                    />
                    <Heading
                      size={"sm"}
                      marginTop={"20px"}
                      marginBottom={"0px"}
                    >
                      Välj logga (frivilligt)
                    </Heading>
                    <Spacer />
                    <LoggoSelector
                      onSelect={(selection: string | null) => {
                        setEvent((old) => {
                          return { ...old, imageSrc: selection };
                        });
                      }}
                      initialSelection={event.imageSrc}
                    />
                  </VStack>
                </div>
              </TabPanel>
              <TabPanel>
                <VStack>
                  <div>Inte implementerad än</div>
                  <Spacer height={"100px"} />
                </VStack>
              </TabPanel>
            </TabPanels>
          </Tabs>
          <Spacer />
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <Spacer />
          <HStack>
            <Button
              hidden={event.id === NOT_VALID_COMPETITION_ID}
              onClick={() => {
                if (event.id !== NOT_VALID_COMPETITION_ID) {
                  if (
                    event.deleted ||
                    window.confirm("Vill du ta bort tävlingen?")
                  ) {
                    props.onSave({ ...event, deleted: !event.deleted });
                  }
                }
              }}
            >
              {event.deleted ? "Återställ" : "Delete"}
            </Button>
            <Button
              onClick={() => {
                if (valid(event)) {
                  props.onSave(event);
                }
              }}
            >
              Spara
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export const FieldValidator = {
  notBlank: (str: string | null | undefined, fieldName?: string) => {
    const notBlank = str !== null && str !== undefined && str.trim().length > 0;
    if (!notBlank && fieldName) {
      toast.warning(`Fältet ${fieldName} måste fyllas i`);
    }
    return notBlank;
  },
  greaterThan: (nr: number, lowerLimit: number, fieldName?: string) => {
    const valid = nr > lowerLimit;
    if (!valid) {
      toast.warning(`Fältet ${fieldName} måste vara större än ${lowerLimit}`);
    }
    return valid;
  },
};

function valid(competition: Competition_GET) {
  return (
    FieldValidator.notBlank(competition.tag, "Tag") &&
    FieldValidator.notBlank(competition.name, "Namn") &&
    FieldValidator.notBlank(competition.place, "Plats") &&
    FieldValidator.notBlank(competition.description, "Tävlings beskrivning")
  );
}

async function fetchFileList() {
  const url = "/api/media/results";
  const response = await requestGET<string[]>(url);
  return response.body || [];
}
